var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartMutedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 102,
    viewBox: "0 0 116 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5821 99.9333C56.2536 100.619 57.1679 101 58.125 101C59.0821 101 59.9964 100.619 60.6679 99.9333L106.354 53.6429C118.215 41.6286 118.215 22.0714 106.354 10.0524C100.592 4.21429 92.9298 1 84.7726 1C76.6155 1 68.9583 4.21429 63.1964 10.0476L58.125 15.1905L53.0536 10.0524C47.2917 4.21429 39.6298 1 31.4774 1C23.3202 1 15.6583 4.21429 9.89643 10.0524C-1.96548 22.0714 -1.96548 41.6286 9.89643 53.6381L55.5821 99.9333ZM14.9774 15.0667C19.3869 10.6048 25.2488 8.14286 31.4726 8.14286C37.7012 8.14286 43.5583 10.6048 47.9631 15.0714L55.5774 22.7857C56.9155 24.1429 59.3202 24.1429 60.6583 22.7857L68.2726 15.0667C72.6917 10.6048 78.5488 8.14286 84.7726 8.14286C91.0012 8.14286 96.8583 10.6048 101.268 15.0667C110.396 24.319 110.396 39.3714 101.268 48.6286L58.125 92.3476L14.9774 48.6238C5.84881 39.3762 5.84881 24.319 14.9774 15.0667Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartMutedGrey);
export default __webpack_public_path__ + "static/media/heart-muted-grey.de29e151aacf6f7af5ec0bbca78b75e0.svg";
export { ForwardRef as ReactComponent };